// set ad views in redux store
export const SET_AD_MODAL_VIEWS = 'SET_AD_MODAL_VIEWS';
export const setAdModalViews = (views) => {
  return {
    type: SET_AD_MODAL_VIEWS,
    views
  };
};



// WEBPACK FOOTER //
// ./src/actions/ad.js